/* Angular Stuff*/
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/* Our Own Stuff*/
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
  selector: 'app-hr-business-unit',
  templateUrl: './../../../templates/forms/modals/business-unit-list.component.html',
})
export class BusinessUnitListComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Input()
  externalValue: number;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "BusinessUnitListGrid"

  businessUnitList:any[] = [];
  searchFields:any[] = ['BU_NAME'];
  public searchString;
  constructor(private dataService: DataLoadService,
    public langService: LangService,
    public gridService:GridService) { 
      this.colObj = [
        { headerName: langService.langData.buName, field: 'BU_NAME', sortable: true, resizable: true, hide: false },
      ];
    }

  ngOnInit() {  
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId); 
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    if(this.externalValue){
      this.dataService.load('FG_HR1137_BU_LIST', JSON.parse(JSON.stringify({P_COMPANY_NO:this.externalValue})) ).subscribe(results=>{
        this.businessUnitList = results.body;
      });
    }else{
      this.dataService.load('FG_SA_COMM_BU').subscribe(results=>{
        this.businessUnitList = results.body;
      });
    }
    
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;   // dataObj is unnecessary as selected-data (_item) can be directly passed to next
    this.submit.next(_item);
  }

} 